import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  DELETE_FAILED_ORDER_DB,
  GET_DELIVERED_COUNTS,
  GET_FAILED_DELIVERED_ORDERS,
  GET_SHOPS,
  MARK_ORDER_DELIVERED_AS_PROCESSED,
  PROCESS_FAILED_DELIVERED_ORDER,
  PROCESS_DELIVERED_ORDER,
  GET_DELIVERED_ORDERS,
} from "../routes";
import { OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import moment from "moment/moment";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";

const Delivered = ({ connection_key }) => {
  const postData = { connection_key: connection_key };

  const [orders, setOrders] = useState([]);

  const [counts, setCounts] = useState({
    failedOrderCount: "",
    currentlyProcessingOrderCount: "",
    unprocessedOrderCount: "",
  });

  const [failedOrders, setFailedOrders] = useState([]);
  const [selectedFailedOrders , setSelectedFailedOrders] = useState([])
  const [failedOrdersEmails, setFailedOrdersEmails] = useState([]);
  const [selectedFailedOrderEmails, setSelectedFailedOrderEmails] = useState(
    []
  );

  const searchBtn = useRef();

  const [processing, setProcessing] = useState(false);

  const [failedOrderProcessing, setFailedOrderProcessing] = useState(false);

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    shop_id: "",
  });

  const [page, setPage] = useState(1);

  const [shops, setShops] = useState([]);

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedTotalOrders, setSelectedTotalOrders] = useState(0);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);


  const handleOrderSelection = (orderMainId) => {
    setSelectedOrders((prevSelectedOrders) => {
      if (prevSelectedOrders.includes(orderMainId)) {
        return prevSelectedOrders.filter((id) => id !== orderMainId);
      } else {
        return [...prevSelectedOrders, orderMainId];
      }
    });
  };

   const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
    } else {
      const allOrderIds = orders.data.map((order) => order.order_main_id);
      setSelectedOrders(allOrderIds);
    }
    setSelectAll(!selectAll);
  };

  const handleBulkProcess = async () => {
    if (selectedOrders.length === 0) {
      toast.error('Please select orders to process!');
      return;
    }

    setCompletedOrders([]);

    try {
      const totalOrders = selectedOrders.length;
      setSelectedTotalOrders(totalOrders);
      for (let i = 0; i < selectedOrders.length; i++) {
        const order_main_id = selectedOrders[i];


        const response = await processOrder(order_main_id);

        setCompletedOrders(prev => [...prev, order_main_id]);
      }

      toast.success('All selected delivered have been processed!');
    } catch (error) {
      toast.error('An error occurred while processing delivered.');
    } finally {
      setProcessing(false);
      setSelectedOrders([]);
      setSelectAll(false);
      getOrders();
      getCounts();
    }
  };

  const getOrders = async () => {
    setOrders([]);
    setProcessing(true);
    await axios
      .post(GET_DELIVERED_ORDERS + "?page=" + page, postData)
      .then((result) => {
        setOrders(result.data.orders);
      })
      .then(() => {
        setProcessing(false);
      });
  };

  const copyToClipboard = (order_id) => {
    var copyText = document.getElementById("response_text" + order_id);
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    toast("Copied!");
  };

  const handleNextPage = async () => {
    if (orders.next_page_url !== null) {
      setOrders([]);
      setProcessing(true);
      let result = await axios.post(
        GET_DELIVERED_ORDERS +
          "?page=" +
          parseInt(page + 1) +
          "&filters=" +
          JSON.stringify(filters),
        postData
      );
      setOrders(result.data.orders);
      setPage(page + 1);
      setProcessing(false);
    }
  };

  const handlePrevPage = async () => {
    if (orders.prev_page_url !== null) {
      setOrders([]);
      setProcessing(true);
      let result = await axios.post(
        GET_DELIVERED_ORDERS +
          "?page=" +
          parseInt(page - 1) +
          "&filters=" +
          JSON.stringify(filters),
        postData
      );
      setOrders(result.data.orders);
      setPage(page - 1);
      setProcessing(false);
    }
  };

  const tooltip = (
    <Tooltip id="tooltip">
      <strong>Copy Response</strong>
    </Tooltip>
  );

  const paginationTooltipPrev = (
    <Tooltip id="paginationTooltipPrev">
      <strong>Prev</strong>
    </Tooltip>
  );

  const paginationTooltipNext = (
    <Tooltip id="paginationTooltipNext">
      <strong>Next</strong>
    </Tooltip>
  );

  const processOrderTooltip = (
    <Tooltip id="processOrderTooltip">
      <strong>Process Delivered</strong>
    </Tooltip>
  );

  const markAsProcessed = (
    <Tooltip id="markAsProcessed">
      <strong>Mark As Processed</strong>
    </Tooltip>
  );

  const notPresentInOrder = (
    <Tooltip id="notPresentInOrder">
      <strong>Not present in delivered</strong>
    </Tooltip>
  );

  const formatDateTime = (value) => {
    return moment(value).format("Do MMM YYYY");
  };

  const performFilter = async () => {
    resetFailedOrders();
    resetFailedOrdersEmails();
    setOrders([]);
    setProcessing(true);
    setSelectedOrders([]);
    setCompletedOrders([]);
    setSelectedTotalOrders(0);
    let payload = false;
    if (
      filters.search !== "" ||
      filters.status !== "" ||
      filters.shop_id !== ""
    ) {
      payload = true;
    } else {
      payload = false;
    }
    let URL = payload ? "&filters=" + JSON.stringify(filters) : "";
    let result = await axios.post(GET_DELIVERED_ORDERS + "?page=" + page + URL, postData);
    setOrders(result.data.orders);
    if (filters.shop_id !== "") {
      getCounts();
    }
    setProcessing(false);
  
  };

  const processOrder = async (order_main_id) => {
    setOrders([]);
    setProcessing(true);
    let res = await axios.post(PROCESS_DELIVERED_ORDER, {
      ...postData,
      order_main_id: order_main_id,
    });
    if (res.data.status === 1) {
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message);
    }
     if (selectedOrders.length == 0) {
        setProcessing(false);
        getOrders();
        getCounts();
      }
  };

  const processFailedOrder = async (order_raw_id) => {
    setFailedOrderProcessing(true);
    let res = await axios.post(PROCESS_FAILED_DELIVERED_ORDER, {
      ...postData,
      id: order_raw_id,
    });
    if (res.data.status === 1) {
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message);
    }
    setFailedOrderProcessing(false);
    await setPage(0);
    setPage(1);
  };

  const resetFilter = async () => {
    setSelectedOrders([]);
    setCompletedOrders([]);
    setSelectedTotalOrders(0);
    setFilters({
      search: "",
      status: "",
      shop_id: "",
    });
    setDummyOptions({ value: "", label: "Select Store" });
    getCounts();
    await setPage(0);
    setPage(1);
    resetFailedOrders();
    resetFailedOrdersEmails();
  };

  const getFailedOrders = async () => {
    setFailedOrderProcessing(true);
    const result = await axios.post(GET_FAILED_DELIVERED_ORDERS, postData);

    await setFailedOrders(result);
    setFailedOrderProcessing(false);
    resetFailedOrdersEmails();
  };

  // export function Start

  // export function End

  const markAsProcessedDB = async (order_id) => {
    setOrders([]);
    setProcessing(true);
    let res = await axios.post(MARK_ORDER_DELIVERED_AS_PROCESSED, {
      ...postData,
      order_id: order_id,
    });
    if (res.data.status === 1) {
      toast.success("Order marked as processed");
    } else {
      toast.success("Something went wrong");
    }
    setProcessing(false);
    getOrders();
    getCounts();
  };

  const generateRawHtml = orders.data?.map((order) => (
    <tr key={order.id}>
      <td className="text-center">
        <div style={{ display: 'flex' }}>
          <OverlayTrigger placement="bottom" overlay={tooltip}>
            <i
              className="fa-solid fa-copy"
              onClick={() => copyToClipboard(order.id)}
            ></i>
          </OverlayTrigger>
          &nbsp;&nbsp;
          <textarea
            id={"response_text" + order.id}
            style={{ display: "none" }}
            defaultValue={order.order_json}
          ></textarea>
          {order.order_save_status === 0 ? (
            order.order_main_id === order.order?.order_main_id ? (
              <>
                <OverlayTrigger placement="bottom" overlay={markAsProcessed}>
                  <i
                    className="fa-solid fa-check text-danger"
                    onClick={() => markAsProcessedDB(order.id)}
                    style={{ cursor: "pointer" }}
                  ></i>
                </OverlayTrigger>
              </>
            ) : (
              <>
                <OverlayTrigger placement="bottom" overlay={processOrderTooltip}>
                  <i
                    className="fa-solid fa-microchip text-danger"
                    onClick={() => processOrder(order.order_main_id)}
                  ></i>
                </OverlayTrigger>
                &nbsp;&nbsp;
                <Form.Check
                    type="checkbox"
                    checked={selectedOrders.includes(order.order_main_id)}
                    onChange={() => handleOrderSelection(order.order_main_id)}
                  />
              </>
              
            )
          ) : null}
          {order.order_save_status === 1 ? (
            order.order_main_id === order.order?.order_main_id ? (
              <i
                className="fa-solid fa-check text-success"
                style={{ cursor: "pointer" }}
              ></i>
            ) : (
              <OverlayTrigger placement="bottom" overlay={notPresentInOrder}>
                <i className="fa-solid fa-microchip text-danger"></i>
              </OverlayTrigger>
            )
          ) : null}
        </div>
      </td>
      <td>{order.shop_id}</td>
      <td>{order.job_id}</td>
      <td>{order.shop}</td>
      <td>
        {order.order_name}
        <br />
        <small>
          <b>({order.id})</b>
        </small>
      </td>
      <td>{order.order_main_id}</td>
      <td>{order.order_date}</td>
      {/* <td className="text-center">
        {(() => {
          const data =
            typeof order.order_json === "string"
              ? JSON.parse(order.order_json)
              : order.order_json;

          return data?.financial_status === "paid" ? (
            <span className="badge bg-success">Paid</span>
          ) : data?.financial_status === "pending" ? (
            <span className="badge bg-secondary">Pending</span>
          ) : (
            "-"
          );
        })()}
      </td> */}
      <td className="text-center">
        {order.order?.order_delivered_status === "delivered" ? (
          <span className="badge bg-secondary">✓ Delivered</span>
        ) : (
          <span className="badge bg-secondary">☐ Undelivered</span>
        )}
      </td>
      
      <td>
        {order.order_save_status === 1 ? (
          <span className="badge bg-success">✓ Processed</span>
        ) : (
          <span className="badge bg-warning">◷ Unprocessed</span>
        )}
      </td>
      <td>{formatDateTime(order.created_at)}</td>
    </tr>
  ));

  const deleteFailedTooltip = (
    <Tooltip id="deleteFailedTooltip">
      <strong>Delete Failed Delivered</strong>
    </Tooltip>
  );

  const deleteFailedOrderBD = async () => {
  if (
      window.confirm(
        "Are you sure you want to delete selected delivered?"
      )
    ) {
      try {
        const res = await axios.post(
          DELETE_FAILED_ORDER_DB,
          {
            ...postData,
            ids: selectedFailedOrders,
          }
        );
        if (res.data.status === 1) {
          toast.success(res.data.message);
          setSelectedFailedOrders([]);
          getFailedOrders();
          getCounts();
        } else {
          toast.warn(
            res.data.message || "Something went wrong!"
          );
        }
      } catch (error) {
        console.error("Bulk delete error:", error);
        toast.error(
          "Failed to delete selected failed order"
        );
      }
    }
  };


  const generateRawHtmlFailedOrders = failedOrders.data?.map((order) => (
    <tr key={order.id}>
      <td className="text-center">
       
      <OverlayTrigger placement="bottom" overlay={deleteFailedTooltip}>
        <input
            id={`select_order_${order.id}`}
            type="checkbox"
            style={{height:"18px" , width:"18px" , cursor:"pointer"}}
            checked={selectedFailedOrders.includes(order.id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedFailedOrders ([
                  ...selectedFailedOrders,
                  order.id,
                ]);
              } else {
                setSelectedFailedOrders(
                  selectedFailedOrders.filter((id) => id !== order.id)
                );
              }
            }}
          />
        </OverlayTrigger>
        &nbsp;&nbsp;
        <OverlayTrigger placement="bottom" overlay={tooltip}>
          <i
            className="fa-solid fa-copy"
            onClick={() => copyToClipboard(order.id)}
          ></i>
        </OverlayTrigger>
        &nbsp;&nbsp;
        <textarea
          id={"response_text" + order.id}
          style={{ display: "none" }}
          defaultValue={order.exception}
        ></textarea>
        <OverlayTrigger placement="bottom" overlay={processOrderTooltip}>
          <i
            className="fa-solid fa-microchip"
            onClick={() => processFailedOrder(order.order_row_id)}
          ></i>
        </OverlayTrigger>
        &nbsp;&nbsp;
      
      </td>
      <td>{order.id}</td>
      <td>{order.order_row_id}</td>
      <td>{formatDateTime(order.failed_at)}</td>
    </tr>
  ));
  const generateRawHtmlFailedOrdersEmails = failedOrdersEmails.data?.map(
    (order) => (
      <tr key={order.id}>
        <td className="text-center">
          <input
            id={`select_order_${order.id}`}
            type="checkbox"
            style={{height:"15px" , width:"15px" , cursor:"pointer"}}
            checked={selectedFailedOrderEmails.includes(order.id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedFailedOrderEmails([
                  ...selectedFailedOrderEmails,
                  order.id,
                ]);
              } else {
                setSelectedFailedOrderEmails(
                  selectedFailedOrderEmails.filter((id) => id !== order.id)
                );
              }
            }}
          />
          <label
            htmlFor={`select_order_${order.id}`}
            style={{ marginLeft: "5px", cursor: "pointer" }}
          >
            <strong>{order.id}</strong>
          </label>
          &nbsp;
        </td>

        <td>{order.shop_domain}</td>
        <td>{order.order_number} </td>
        <td>{formatDateTime(order.failed_at)}</td>
      </tr>
    )
  );

  const loader = () => {
    return (
      <tr>
        <td colSpan={11} className="text-center">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle id="test" cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </td>
      </tr>
    );
  };

  const resetFailedOrders = () => {
    setFailedOrders([]);
  };

  const resetFailedOrdersEmails = () => {
    setFailedOrdersEmails([]);
  };

  const searchTooltip = (
    <Tooltip id="searchTooltip">
      <strong>Search</strong>
    </Tooltip>
  );

  const resetTooltip = (
    <Tooltip id="resetTooltip">
      <strong>Reset</strong>
    </Tooltip>
  );

  const refreshToolTip = (
    <Tooltip id="refreshToolTip">
      <strong>Refresh</strong>
    </Tooltip>
  );

  let options = [{ value: "", label: "Select Store" }];

  const [dummyOptions, setDummyOptions] = useState({
    value: "",
    label: "Select Store",
  });

  const refreshData = () => {
    searchBtn.current.click();
    resetFailedOrders();
    resetFailedOrdersEmails();
    setSelectedOrders([]);
    setCompletedOrders([]);
    setSelectedTotalOrders(0);
  };

  const getCounts = async () => {
    setProcessing(true);
    let params =
      filters.shop_id !== "" ? "?filters=" + JSON.stringify(filters) : "";
    let result = await axios.post(GET_DELIVERED_COUNTS + params, postData);
    setCounts({
      failedOrderCount: result.data.failedOrderCount,
      currentlyProcessingOrderCount: result.data.currentlyProcessingOrderCount,
      unprocessedOrderCount: result.data.unprocessedOrderCount,
    });
    setProcessing(false);
  };

  const getShops = async () => {
    const result = await axios.post(GET_SHOPS, postData);
    setShops(result.data);
  };

  shops &&
    shops.map((value) =>
      options.push({
        value: value.id,
        label: value.shop,
      })
    );

  useEffect(() => {
    if (page !== 0) {
      getOrders();
      getCounts();
      getShops();
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <>
      <div className="container mt-3">
        <ToastContainer autoClose={1500} />
        <h5>
          {connection_key === "main_connection" ?
            "Delivered Orders (" : null}
          Database :&nbsp;
          {connection_key === "main_connection"
            ? "Master)"
            : connection_key + ".myshopify.com"}
        </h5>
        <div className="filters">
          <div className="row mt-3 shop-list">
            <div className="col-md-3 col-lg-3 col-sm-6">
              {shops.length ? (
                <Select
                  options={options}
                  value={dummyOptions}
                  onChange={(event) => {
                    setFilters({ ...filters, shop_id: event.value });
                    setDummyOptions({ value: event.value, label: event.label });
                  }}
                />
              ) : (
                <div id="loader"></div>
              )}
            </div>
            <div className="col-md-3 col-lg-3 col-sm-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={filters.search}
                onChange={(event) =>
                  setFilters({ ...filters, search: event.target.value })
                }
              />
            </div>
            <div className="col-md-3 col-lg-3 col-sm-6">
              <select
                className="form-select"
                value={filters.status}
                onChange={(event) =>
                  setFilters({ ...filters, status: event.target.value })
                }
              >
                <option value="">Select Status</option>
                <option value={1}>Processed</option>
                <option value={0}>Unprocessed</option>
              </select>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 text-end" style={{ color: "red" }}>
                  {completedOrders.length > 0 ? (
                  <>
                    <label>Manually Completed Delivered :{" "}<strong>{completedOrders.length}/{selectedTotalOrders}</strong></label>
                  </>
                ) : null}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6 col-lg-6 col-sm-12">
              <button
                className="btn btn-primary btn-sm"
                type="button"
                onClick={performFilter}
                ref={searchBtn}
              >
                <OverlayTrigger placement="bottom" overlay={searchTooltip}>
                  <i className="fa-solid fa-magnifying-glass"></i>
                </OverlayTrigger>
              </button>
              &nbsp;
              <button
                className="btn btn-primary btn-sm"
                type="button"
                onClick={refreshData}
              >
                <OverlayTrigger placement="bottom" overlay={refreshToolTip}>
                  <i className="fa-solid fa-arrows-rotate"></i>
                </OverlayTrigger>
              </button>
              &nbsp;
              <button
                className="btn btn-primary btn-sm"
                type="button"
                onClick={resetFilter}
              >
                <OverlayTrigger placement="bottom" overlay={resetTooltip}>
                  <i className="fa-solid fa-rotate-right"></i>
                </OverlayTrigger>
              </button>
              &nbsp;
              {failedOrders.length > 0 ? (
                <button
                  className="btn btn-danger btn-sm"
                  type="button"
                  onClick={getFailedOrders}
                >
                  <i className="fa-regular fa-circle-xmark"></i> Failed Delivered
                </button>
              ) : null}
              &nbsp;
              {selectedFailedOrders.length > 0 && (
                <button
                  className="btn btn-danger btn-sm "
                  type="button"
                  onClick={deleteFailedOrderBD}
                >
                  <i className="fa-solid fa-trash"></i> Delete Failed Delivered (
                  {selectedFailedOrders.length})
                </button>
              )}
              {selectedOrders.length > 0 ? <><button 
                  onClick={handleBulkProcess} 
                  disabled={processing}
                  className="btn btn-primary btn-sm"
                  type="button"
                >
                  {processing ? 'Processing...' : `Process Selected Orders (${selectedOrders.length})`}
                </button> </> : null}
            </div>
              
          </div>
        </div>
        <div className="row mt-3 wpcb-utility-order-details">
          <div className="col-md-4">
            <label>
              {counts.unprocessedOrderCount !== "" ? (
                <>
                  <i className="fa-solid fa-box-open" style={{ fontSize: "smaller" }}></i>&nbsp;Unprocessed Delivered :{" "}
                  <strong>{counts.unprocessedOrderCount}</strong>
                </>
              ) : (
                <div id="loader"></div>
              )}
            </label>
          </div>
          <div className="col-md-4">
            <label>
              {counts.failedOrderCount !== "" ? (
                <>
                  <span>
                    {" "}
                    <i className="fa-solid fa-circle-xmark" style={{ fontSize: "smaller" }}></i>&nbsp;Failed Delivered : <strong>
                      {counts.failedOrderCount}
                    </strong>{" "}
                  </span>
                </>
              ) : (
                <div id="loader"></div>
              )}
            </label>
          </div>
          <div className="col-md-4">
            <label>
              {counts.currentlyProcessingOrderCount !== "" ? (
                <>
                  <i className="fa-solid fa-arrows-rotate" style={{ fontSize: "smaller" }}></i>&nbsp;Currently Processing Delivered :{" "}
                  <strong>{counts.currentlyProcessingOrderCount}</strong>
                </>
              ) : (
                <div id="loader"></div>
              )}
            </label>
          </div>
        </div>
        {failedOrders.data?.length > 0 ? (
          <div className="box mt-3" style={{ position: "relative" }}>
            <div className="box-body">
              <div className="table-responsive-lg">
                <i
                  className="fa-solid fa-xmark"
                  onClick={resetFailedOrders}
                ></i>
                <table className="table sub-table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" className="col-1 text-center">
                        Actions
                        &nbsp;
                        {selectedFailedOrders.length > 0 && (
                          <>
                            <input
                              type="checkbox"
                              id={`select_all_order`}
                              style={{cursor:"pointer"}}
                              className="text-blue"
                              checked={
                                failedOrders.data?.length > 0 &&
                                selectedFailedOrders.length ===
                                  failedOrders.data.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedFailedOrders(
                                    failedOrders.data.map(
                                      (order) => order.id
                                    )
                                  );
                                } else {
                                  setSelectedFailedOrders([]);
                                }
                              }}
                            />
                            &nbsp;
                            <label
                              htmlFor={`select_all_order`}
                              type="button"
                              className="text-blue link-primary"
                            >
                              {selectedFailedOrders.length === failedOrders.data?.length
                                ? 'Selected all'
                                : `Selected ${selectedFailedOrders.length}`}
                            </label>
                          </>
                        )}
                      </th>
                      <th scope="col" className="col-1">
                        ID
                      </th>
                      <th scope="col" className="col-1">
                        Order Row ID
                      </th>
                      <th scope="col" className="col-1">
                        Failed At
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {failedOrderProcessing
                      ? loader()
                      : generateRawHtmlFailedOrders}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}
        {failedOrdersEmails.data?.length > 0 ? (
          <div className="box mt-3 mb-5" style={{ position: "relative" }}>
            <div className="box-body">
              <div className="table-responsive-lg" style={{height: "100%", maxHeight: "400px" }}>
                <i
                  className="fa-solid fa-xmark z-3"
                  onClick={resetFailedOrdersEmails}
                ></i>

                <table className="table sub-table table-striped table-bordered">
                  <thead style={{position:"sticky", top:"0", zIndex:"1"}}>
                    <tr>
                      <th scope="col" className="col-1 text-center">
                        Job Id &nbsp;
                        
                        {selectedFailedOrderEmails.length > 0 && (
                          <>
                            <input
                              type="checkbox"
                              id={`select_all_order`}
                              style={{cursor:"pointer"}}
                              className="text-blue"
                              checked={
                                failedOrdersEmails.data?.length > 0 &&
                                selectedFailedOrderEmails.length ===
                                  failedOrdersEmails.data.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedFailedOrderEmails(
                                    failedOrdersEmails.data.map(
                                      (order) => order.id
                                    )
                                  );
                                } else {
                                  setSelectedFailedOrderEmails([]);
                                }
                              }}
                            />
                            &nbsp;
                            <label
                              htmlFor={`select_all_order`}
                              type="button"
                              className="text-blue link-primary"
                            >
                              {selectedFailedOrderEmails.length === failedOrdersEmails.data?.length
                                ? 'Selected all'
                                : `Selected ${selectedFailedOrderEmails.length}`}
                            </label>
                          </>
                        )}
                      </th>

                      <th scope="col" className="col-1">
                        Shop
                      </th>
                      <th scope="col" className="col-1">
                        Order Number
                      </th>
                      <th scope="col" className="col-1">
                        Failed At
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {failedOrderProcessing
                      ? loader()
                      : generateRawHtmlFailedOrdersEmails}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}
        <div className="box mt-3">
          <div className="box-body">
            <div className="table-responsive-lg">
              <table className="table sub-table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col" className="col-1" style={{ display: 'flex' }}>
                      Actions
                      &nbsp;
                      {selectedOrders.length > 0 && !processing ?
                        <Form.Check
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      :null}
                    </th>
                    <th scope="col" className="col-1">
                      Shop ID
                    </th>
                    <th scope="col" className="col-1">
                      Job ID
                    </th>
                    <th scope="col" className="col-1">
                      Store Name
                    </th>
                    <th scope="col" className="col-1">
                      Order Name
                    </th>
                    <th scope="col" className="col-1">
                      Order Main ID
                    </th>
                    <th scope="col" className="col-1">
                      Order Date
                    </th>
                    {/* <th scope="col" className="col-1">
                      Financial Status
                    </th> */}
                    <th scope="col" className="col-1">
                      Delivered Status
                    </th>
                    <th scope="col" className="col-1 text-center">
                      Status
                    </th>
                    <th scope="col" className="col-1">
                      Created On
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length === 0 ? loader() : generateRawHtml}
                </tbody>
              </table>
            </div>
          </div>
          {!processing ? (
            <div className="box-footer">
              <nav>
                <ul className="pagination align-items-center">
                  <li className="page-item">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={paginationTooltipPrev}
                    >
                      <span className="page-link" onClick={handlePrevPage}>
                        <span aria-hidden="true">&laquo;</span>
                      </span>
                    </OverlayTrigger>
                  </li>

                  <li className="page-item">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={paginationTooltipNext}
                    >
                      <span className="page-link" onClick={handleNextPage}>
                        <span aria-hidden="true">&raquo;</span>
                      </span>
                    </OverlayTrigger>
                  </li>

                  <li className="page-item ms-auto">
                    <span className="page-link">
                      Current Page: <strong>{page}</strong>
                    </span>
                  </li>
                </ul>
              </nav>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
    </>
  );
};

export default Delivered;
